import { createStyles, makeStyles, Theme, space } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    maxWidth: space.singleColumnMaxWidth,
    margin: '0 auto',
    marginTop: 40,
    marginBottom: 130,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 190,
      marginTop: 32,
    },
  },
  box: {
    padding: '30px 40px',
    borderRadius: 8,
    backgroundColor: theme.color.greys[0],
    [theme.breakpoints.down('xs')]: {
      padding: '28px 16px',
    },
  },
  entrepreneurBox: {
    marginTop: 0,
    '& .MuiGrid-container': {
      margin: 0,
      boxShadow: 'none',
      [theme.breakpoints.down('xs')]: {
        marginBottom: 90,
      },
    },
  },
}), {name: 'TransferIkzeEntrepreneur'});
